"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.twMerge = void 0;
const tailwind_merge_1 = require("tailwind-merge");
exports.twMerge = (0, tailwind_merge_1.extendTailwindMerge)({
    prefix: "ko:",
});
